<template>
    <RouterLink :to="to" class="link-wrapper">
        <BaseCard
            class="entity-card"
            :entity="enrichedEntity || entity"
            :tags="tags || []"
            :showPath="false"
            :entityType="entityType"
            :borderColor="borderColor"
        />
    </RouterLink>
</template>

<script setup lang="ts">
import { RouterLink, type RouterLinkProps } from "vue-router";

import { EntityType, useEntityManager } from "@/stores/entity-store";

import BaseCard from "./BaseCard.vue";

const props = defineProps<{
    entity: {
        identity: string;
        name: string;
        short_description?: string | null;
        thumbnail?: string | null;
    };
    tags?: {
        label: string;
        severity: "primary" | "secondary" | "info";
    }[];
    entityType: EntityType;
    borderColor?: string;
    to: RouterLinkProps["to"];
}>();

// Get additional entity information from the info endpoint.
const { entity: enrichedEntity } = useEntityManager(
    props.entityType,
    props.entity.identity
);
</script>

<style lang="scss" scoped>
.link-wrapper {
    text-decoration: initial;
    color: initial;
}

.entity-card {
    // Assign the browser default background
    --sl-panel-background-color: Canvas;
    --shadow-color: color-mix(in srgb, var(--text-color) 24%, transparent);

    cursor: pointer;
    transition: 0.3s ease;
    height: 100%;
    max-width: 100%;
    min-height: 200px;
    box-shadow:
        0 1px 3px 0 var(--shadow-color),
        0 1px 2px -1px var(--shadow-color);
    transition: 250ms ease;

    &::part(base) {
        height: 100%;
    }

    &:hover {
        --sl-panel-background-color: var(--surface-background-mild);

        transform: scale(1.01);
    }
}
</style>
